import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Blockquote } from '#app/components/typography/blockquote.tsx'
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Blockquote',
}

const component: componentProps = {
	name: 'Blockquote',
	shortName: 'Blockquote',
	fileName: 'blockquote',
	category: 'typography',
	description: ['A blockquote component.'],
	features: ['Drop-in replacement for the native <blockquote> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<Blockquote cite="http://www.worldwildlife.org/who/index.html">
	<P>
		For 50 years, WWF has been protecting the future of nature. The world's leading conservation organization, WWF works in 100 countries and is supported by 1.2 million members
		in the United States and close to 5 million globally.
	</P>
</Blockquote>`,
	styling: `.blockquote {
	@apply text-fluid-md border-muted-200 my-fluid-13 text-muted-900 pl-fluid-8 max-w-prose border-l-4 font-medium italic;

	& > .p:first-of-type {
		@apply before:content-[open-quote];
	}
	& > .p {
		@apply text-muted-900 my-0 font-medium;
	}
	& > .p:last-of-type {
		@apply after:content-[close-quote];
	}
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<Blockquote cite="http://www.worldwildlife.org/who/index.html">
				<P>
					For 50 years, WWF has been protecting the future of nature. The world's leading conservation organization, WWF works in 100 countries and is supported by 1.2 million members
					in the United States and close to 5 million globally.
				</P>
			</Blockquote>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
